﻿import React, { useContext, useState } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import Content_Container from '@Elements/Content_Container';
import AnimateHeight from 'react-animate-height';
import { P } from '@Elements/Fonts';
import { Projects_List_Item } from '@Modules/UsualProjects_Module';

import {
    Customer,
    All_Projects_Customer_Item_Props,
    Project
} from '@Util/Types';

export default function AllProjects_Module(): JSX.Element {
    const [t] = useTranslation();
    const { customers }: context_type = useContext(Context);
    const [module_height, set_module_height] = useState<"auto" | 0>(0);

    return (
        <section className="Module AllProjects_Module">
            <header
                className={`Module_Header Module_Header_WithExpansion ${module_height === "auto" ? "Module_Header_WithExpansion--Active" : ""}`}
                onClick={() => set_module_height(module_height === "auto" ? 0 : "auto")}
                aria-controls="all_projects_module"
                aria-expanded={module_height === "auto" ? true : false}
            >
                <h2 className="Headline2">{t('Text.AllProjects')}</h2>
                <svg aria-label="hidden" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M540-480 356-664l20-20 204 204-204 204-20-20 184-184Z" /></svg>
            </header>
            <AnimateHeight
                id="all_projects_module"
                duration={250}
                height={module_height}
            >
                <Content_Container>
                    <ul className="Module_All_Projects">
                        {customers?.map((customer: Customer, index: number): JSX.Element => (
                            <All_Projects_Customer_Item
                                key={customer.id.toString()}
                                customer={customer}
                                index={index}
                            />
                        ))}
                    </ul>
                </Content_Container>
            </AnimateHeight>
        </section>
    );
}

const All_Projects_Customer_Item: React.FC<All_Projects_Customer_Item_Props> = React.memo((props) => {
    const [customer_height, set_customer_height] = useState<"auto" | 0>(0);

    return (
        <li className={`Module_All_Projects_List_Item ${customer_height === "auto" ? "Module_All_Project_List_Item--Active" : ""}`}>
            <button
                type="button"
                className="Module_All_Projects_List_Item_Button"
                onClick={() => set_customer_height(customer_height === 0 ? "auto" : 0)}
                aria-expanded={customer_height === "auto" ? true : false}
                aria-controls={`all_projects_customer_${props.customer.id.toString()}`}
            >
                <span
                    className="Customer_Color"
                    style={{ backgroundColor: `rgb(${props.customer.color})` }}
                    aria-label="hidden"
                ></span>
                <P>{props.customer.name}</P>
                <svg aria-label="hidden" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M540-480 356-664l20-20 204 204-204 204-20-20 184-184Z" /></svg>
            </button>
            <AnimateHeight
                id={`all_projects_customer_${props.customer.id.toString()}`}
                duration={250}
                height={customer_height}
            >
                <ul className="Module_Project_List">
                    {props.customer.projects
                        .filter((project: Project) => !project.isArchived)
                        .map((project: Project, index: number): JSX.Element => (
                            <Projects_List_Item
                                key={`${props.customer.id.toString()}_${project.id.toString()}`}
                                project={{
                                    projectId: project.id,
                                    customerName: props.customer.name,
                                    customerColor: props.customer.color,
                                    projectName: project.name
                                }}
                                index={index}
                                show_color={false}
                                show_customer_name={false}
                            />
                        ))
                    }
                </ul>
            </AnimateHeight>
        </li>
    );
});